var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notes",class:{ open: _vm.open }},[_c('div',{staticClass:"button",on:{"click":_vm.toggle}},[_c('CommentIcon')],1),_c('div',{staticClass:"content"},[_c('h3',[_vm._v("Notizen")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }